import React, { MouseEvent } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { Box, Checkbox, Link } from '@mui/material';

type Props = {
  onGroupToggle: (index: number) => () => void;
  getAmenities: (amenities: Array<App.Amenity>) => string;
  getEditUrl: (id: string) => string;
  value: {
    index: number;
    group: App.AmenityGroup & { checked: boolean };
  };
};

export default function SortableItem({ onGroupToggle, getAmenities, getEditUrl, value }: Props) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: value.group.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const toggleHandler = onGroupToggle(value.index);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
  };

  const handleCheckboxClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    toggleHandler();
  };

  const handleLinkClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <Box
      component="li"
      ref={setNodeRef}
      style={style}
      className="sortable-amenity-group"
      data-list-order={value.group.order}
      {...attributes}
    >
      <Box className="sortable-amenity-group-inner" {...listeners}>
        <Box className="sortable-amenity-group-inner-left">
          <Checkbox
            checked={value.group.checked}
            onChange={handleCheckboxChange}
            onClick={handleCheckboxClick}
            sx={{ pointerEvents: 'auto' }}
          />
          <Box component="span" className="sortable-amenity-group-index">
            {value.index + 1}.
          </Box>{' '}
          <Box component="span" className="sortable-amenity-group-location">
            {value.group.name}
          </Box>
          <Box component="span">&nbsp;| {getAmenities(value.group.amenities)}</Box>
        </Box>
        <Box className="sortable-amenity-group-inner-right">
          <Box className="sortable-amenity-group-link">
            <Link href={getEditUrl(value.group.id)} target="_blank" rel="noreferrer" onClick={handleLinkClick}>
              Edit
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
